"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchById = exports.useFetchByApplication = exports.usePlanUpdate = exports.usePlanCreate = exports.usePlanFetch = void 0;
const react_redux_1 = require("react-redux");
const planAction_1 = require("./planAction");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
function usePlanFetch() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchPlanLoading = (0, react_redux_1.useSelector)((state) => state['plan/fetch'].loading);
    const fetchPlanData = (0, react_redux_1.useSelector)((state) => state['plan/fetch'].data);
    const fetchPlanError = (0, react_redux_1.useSelector)((state) => state['plan/fetch'].error);
    const fetchPlan = (payload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, planAction_1.fetch)(payload));
    });
    return { fetchPlan, fetchPlanLoading, fetchPlanData, fetchPlanError };
}
exports.usePlanFetch = usePlanFetch;
function usePlanCreate() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const createPlanLoading = (0, react_redux_1.useSelector)((state) => state['plan/create'].loading);
    const createPlanData = (0, react_redux_1.useSelector)((state) => state['plan/create'].data);
    const createPlanError = (0, react_redux_1.useSelector)((state) => state['plan/create'].error);
    const createPlan = (payload, onComplete) => __awaiter(this, void 0, void 0, function* () {
        try {
            let result = yield (0, AuthGuard_1.isLoggedIn)();
            if (!result) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, planAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Plan created successfully');
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Plan creation failed');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return { createPlan, createPlanLoading, createPlanData, createPlanError };
}
exports.usePlanCreate = usePlanCreate;
function usePlanUpdate() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const updatePlanLoading = (0, react_redux_1.useSelector)((state) => state['plan/update'].loading);
    const updatePlanData = (0, react_redux_1.useSelector)((state) => state['plan/update'].data);
    const updatePlanError = (0, react_redux_1.useSelector)((state) => state['plan/update'].error);
    const updatePlan = (payload, onComplete) => __awaiter(this, void 0, void 0, function* () {
        try {
            let result = yield (0, AuthGuard_1.isLoggedIn)();
            if (!result) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, planAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Plan updated successfully');
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Plan updation failed');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return { updatePlan, updatePlanLoading, updatePlanData, updatePlanError };
}
exports.usePlanUpdate = usePlanUpdate;
function useFetchByApplication() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchPlanByApplicationLoading = (0, react_redux_1.useSelector)((state) => state['plan/fetchByApplication'].loading);
    const fetchPlanByApplicationData = (0, react_redux_1.useSelector)((state) => state['plan/fetchByApplication'].data);
    const fetchPlanByApplicationError = (0, react_redux_1.useSelector)((state) => state['plan/fetchByApplication'].error);
    const fetchPlanByApplication = (payload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, planAction_1.fetchByApplication)(payload));
    });
    return { fetchPlanByApplication, fetchPlanByApplicationLoading, fetchPlanByApplicationData, fetchPlanByApplicationError };
}
exports.useFetchByApplication = useFetchByApplication;
function useFetchById() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchPlanByIdLoading = (0, react_redux_1.useSelector)((state) => state['plan/fetchById'].loading);
    const fetchPlanByIdData = (0, react_redux_1.useSelector)((state) => state['plan/fetchById'].data);
    const fetchPlanByIdError = (0, react_redux_1.useSelector)((state) => state['plan/fetchById'].error);
    const fetchPlanById = (payload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, planAction_1.fetchById)(payload));
    });
    return { fetchPlanById, fetchPlanByIdLoading, fetchPlanByIdData, fetchPlanByIdError };
}
exports.useFetchById = useFetchById;
